<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="medium"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_function_code') || '功能编码'"
            prop="funcID"
          >
            <el-input v-model="formData.funcID"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_staff_code') || '操作人员'"
            prop="userCode"
          >
            <dict-select
              clearable
              v-model="formData.userCode"
              :body="{}"
              url="/sys/common/dict/userDict"
              placeholder=""
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_log_type') || '日志类型'"
            prop="logType"
          >
            <el-input v-model="formData.logType"> </el-input>
          </el-form-item>
        </el-col>
         <el-col :span="8">
          <el-form-item
            :label="$l('form_label_ip') || '操作ip'"
            prop="ip"
          >
            <el-input v-model="formData.ip"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_duration') || '请求耗时(秒)'"
            prop="duration"
          >
            <el-input v-model="formData.duration"> </el-input>
          </el-form-item>
        </el-col>
          <el-col :span="24">
          <el-form-item
            :label="$l('form_label_ua') || '代理信息'"
            prop="ua"
          >
            <el-input
              type="textarea"
              rows="3"
              v-model="formData.ua"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_log_explain') || '日志说明'"
            prop="logDescription"
          >
            <el-input
              type="textarea"
              rows="3"
              v-model="formData.logDescription"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    logCode: String,
  },
  data() {
    return {
      backDialogVisible: false,
      regionShow: false,
      formData: {},
      rules: {
        logCode: [
          {
            required: true,
            message:
              this.$l('form_label_pleaseEnter_the_logging_code') ||
              '请输入日志内码',
            trigger: 'blur',
          },
        ],
        userCode: [
          {
            required: true,
            message:
              this.$l('form_label_pleaseEnter_staff_code') || '请输入人员内码',
            trigger: 'blur',
          },
        ],
        logDescription: [
          {
            required: true,
            message:
              this.$l('form_label_pleaseEnter_log_explain') || '请输入日志说明',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
    this.regionShow = true
  },
  methods: {
    getData() {
      if (!this.logCode) return
      this.$api
        .sysMerchantDetailApi({
          logCode: this.logCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      this.$api
        .sysMerchantSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
